import App from '@/app';

export default function Call() {
  return (
    <App />
  );
}
